import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { normalizeRouteColor } from "./routeDisplay.js";
export function buildSelectedTripData({
  tripDetails,
  selectedItem,
  isDark,
  routeDisplayOptions
}) {
  if (!tripDetails) {
    return null;
  }
  const trip = tripDetails.trip || null;
  const route = tripDetails.route || null;
  const stops = Array.isArray(tripDetails.stopTimesTrip) ? tripDetails.stopTimesTrip : Array.isArray(tripDetails.stops) ? tripDetails.stops : [];
  const shape = Array.isArray(tripDetails.shape) ? tripDetails.shape : [];
  const routeColor = selectedItem.routeColor || route?.route_color || trip?.route_color || null;
  const routeType = selectedItem.routeType ?? route?.route_type ?? trip?.route_type;
  const routeLabel = selectedItem.routeLabel || route?.route_short_name || trip?.route_short_name || null;
  return {
    trip,
    route,
    stops,
    shape,
    selectedTripShape: {
      tripId: trip?.trip_id || selectedItem.trip_id,
      // Match the trip page's route display contract. Region-specific display
      // overrides are deliberately opt-in at the map surface.
      routeColor: normalizeRouteColor(routeColor, routeType, routeLabel, routeDisplayOptions),
      isDark,
      shape
    }
  };
}
export function useSelectedTripShape(t0) {
  const $ = _c(9);
  const {
    selectedItem,
    isDark,
    tripDetails,
    routeDisplayOptions
  } = t0;
  const isVehicleTripSelection = selectedItem?.type === "vehicle" && Boolean(selectedItem.trip_id);
  let t1;
  if ($[0] !== isDark || $[1] !== isVehicleTripSelection || $[2] !== routeDisplayOptions || $[3] !== selectedItem || $[4] !== tripDetails) {
    t1 = isVehicleTripSelection ? buildSelectedTripData({
      tripDetails,
      selectedItem,
      isDark,
      routeDisplayOptions
    }) : null;
    $[0] = isDark;
    $[1] = isVehicleTripSelection;
    $[2] = routeDisplayOptions;
    $[3] = selectedItem;
    $[4] = tripDetails;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const selectedTripData = t1;
  const t2 = selectedTripData?.selectedTripShape || null;
  let t3;
  if ($[6] !== selectedTripData || $[7] !== t2) {
    t3 = {
      selectedTripData,
      selectedTripShape: t2
    };
    $[6] = selectedTripData;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}